import { render, staticRenderFns } from "./AlertsPage.vue?vue&type=template&id=40bcb40a&scoped=true&"
import script from "./AlertsPage.vue?vue&type=script&lang=js&"
export * from "./AlertsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bcb40a",
  null
  
)

export default component.exports